import { Component, ErrorHandler, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
 import * as FileSaver from 'file-saver';
 import * as XLSX from 'xlsx';

 const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
 const EXCEL_EXTENSION = '.xlsx';


@Component({
  selector: 'app-overallreport',
  templateUrl: './overallreport.component.html',
  styleUrls: ['./overallreport.component.css']
})
export class OverallreportComponent implements OnInit {
  e:any={};
  UsersList: any=[];
  TicketsList: any=[];
  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    // this.GetAllInternalUsers();
  }

  overallreport = function(){
    debugger
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.overallreport(this.e.FromDate,this.e.ToDate)
    .subscribe((data:any)=>{
      this.TicketsList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}


exportAsXLSX():void {
  this.exportAsExcelFile(this.TicketsList, 'sample');
}
exportAsXLS():void {
  this.exportAsExcelFile(this.TicketsList, 'sample');
}



  public exportAsExcelFile(json: any[], excelFileName: string): void {
    
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log('worksheet',worksheet);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

}


// WEBPACK FOOTER //
// ./src/app/reports/overallreport/overallreport.component.ts